/**
 * 売上管理
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'
 import * as types from '../../../mutation-types/driver-types'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/sales/deals`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      /* 一覧表示件数 */
      limit: 50,
      /* ステータス */
      status: null,
      /* 取引日(from) */
      trading_start_date: null,
      /* 取引日(to) */
      trading_end_date: null,
      /* 現掛区分 */
      receivable_type: null,
      /* 営業担当者 */
      sales_staff: null,
      /* 取引先(排出)事業者ID */
      supplier_id: null,
      /* 取引先(排出)事業者区分 */
      supplier_type: "Emission",
      /* 取引先(排出)事業場ID */
      supplier_location_id: null,
      /* 取引先(排出)事業場コード */
      supplier_location_code: null,
      /* 取引先(収運・処分)事業者ID */
      supplier_trader_id: null,
      /* 取引先(収運・処分)事業者区分 */
      supplier_trader_type: "Trader",
      /* 取引先(収運・処分)事業場ID */
      supplier_trader_location_id: null,
      /* 取引先(収運・処分)事業場コード */
      supplier_trader_location_code: null,
      /* 請求先ID */
      billing_id: null,
      /* 取引番号・引取搬入番号, 受注番号 */
      keyword: null,
      /* 表示順 */
      sort_type: "updated_date_desc",
    },
  }
}

const sales_deal = {

  namespaced: true,
  state: getDefaultState(),
  getters: {},
  actions: {
    /**
     * 取引一覧
     * @param dispatch
     * @param commit
     * @param state
     * @param params { Object } 検索条件
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { params }) {

      dispatch('saveCondition', { params: params})
      const parameters = {
        ...state.condition,
        page: params.page,
        format: params.format,
      }
      let api_path
      if (params.format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = `${API_PATH}`
      }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: parameters }).then(data => {
          if ((params.format !== 'csv')) {
            let content = data.content
            commit(types.DRIVER_SALES_DEAL_PAGINATION, { content })
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    /**
     * 取引詳細
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 取引新規
     * @return {Promise<unknown>}
     */
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 取引編集
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    /**
     * 取引削除
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { params }) {
      const _status = (params.status !== undefined) ? params.status : state.condition.status
      const _trading_start_date = (params.trading_start_date !== undefined) ? params.trading_start_date : state.condition.trading_start_date
      const _trading_end_date = (params.trading_end_date !== undefined) ? params.trading_end_date : state.condition.trading_end_date
      const _receivable_type = (params.receivable_type !== undefined) ? params.receivable_type : state.condition.receivable_type
      const _sales_staff = (params.sales_staff !== undefined) ? params.sales_staff : state.condition.sales_staff
      const _supplier_id = (params.supplier_id !== undefined) ? params.supplier_id : state.condition.supplier_id
      const _supplier_type = (params.supplier_type !== undefined) ? params.supplier_type : state.condition.supplier_type
      const _supplier_location_id = (params.supplier_location_id !== undefined) ? params.supplier_location_id: state.condition.supplier_location_id
      const _supplier_location_code = (params.supplier_location_code !== undefined) ? params.supplier_location_code: state.condition.supplier_location_code
      const _supplier_trader_id = (params.supplier_trader_id !== undefined) ? params.supplier_trader_id : state.condition.supplier_trader_id
      const _supplier_trader_type = (params.supplier_trader_type !== undefined) ? params.supplier_trader_type : state.condition.supplier_trader_type
      const _supplier_trader_location_id = (params.supplier_trader_location_id !== undefined) ? params.supplier_trader_location_id: state.condition.supplier_trader_location_id
      const _supplier_trader_location_code = (params.supplier_trader_location_code !== undefined) ? params.supplier_trader_location_code: state.condition.supplier_trader_location_code
      const _billing_id = (params.billing_id !== undefined) ? params.billing_id : state.condition.billing_id
      const _keyword = (params.keyword !== undefined) ? params.keyword : state.condition.keyword
      const _sort_type = (params.sort_type !== undefined) ? params.sort_type : state.condition.sort_type
      const _limit = (params.limit !== undefined) ? params.limit : state.condition.limit

      const conditions = {
        status: _status,
        trading_start_date: _trading_start_date,
        trading_end_date: _trading_end_date,
        receivable_type: _receivable_type,
        sales_staff: _sales_staff,
        supplier_id: _supplier_id,
        supplier_type: _supplier_type,
        supplier_location_id: _supplier_location_id,
        supplier_location_code: _supplier_location_code,
        supplier_trader_id: _supplier_trader_id,
        supplier_trader_type: _supplier_trader_type,
        supplier_trader_location_id: _supplier_trader_location_id,
        supplier_trader_location_code: _supplier_trader_location_code,
        billing_id: _billing_id,
        keyword: _keyword,
        sort_type: _sort_type,
        limit: _limit,
      }
      commit(types.DRIVER_SALES_DEAL_CONDITION, { params: conditions })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_SALES_DEAL_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_SALES_DEAL_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_SALES_DEAL_CONDITION] (state, { params }) {
      Object.assign(state.condition, params);
    },
    [types.DRIVER_SALES_DEAL_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_SALES_DEAL_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_SALES_DEAL_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
  },


}
export default sales_deal
